//创建一个路由
import Router from "vue-router";
import { Message, MessageBox } from 'element-ui'
import MainPage from '../pages/MainPage.vue'
import NoticePage from "@/pages/NoticePage.vue";
import LoginPage from "@/pages/LoginPage.vue";
import RegisterPage from "@/pages/RegisterPage.vue";
import AdminPage from "@/pages/AdminPage.vue";
import BackstageNotice from "@/pages/BackstageNotice.vue";
import BackstageUser from "@/pages/BackstageUser.vue";
import UserInfo from "@/pages/UserInfo.vue";
import BackstageAdmin from "@/pages/BackstageAdmin.vue";
import CommunityPage from "@/pages/CommunityPage.vue";
import DetailComPage from "@/pages/DetailComPage.vue";
import AllNotice from "@/pages/AllNotice.vue";
import GoodsPage from "@/pages/GoodsPage.vue";
import DetailGoodsPage from "@/pages/DetailGoodsPage.vue";
import CarDialog from "@/components/CarDialog.vue";
import SellGoods from "@/pages/SellGoods.vue";
import MesPage from "@/pages/MesPage.vue";
import HandelInfo from "@/pages/HandelInfo.vue";
import ExamineArticle from "@/pages/ExamineArticle.vue";
import UserData from "@/pages/UserData.vue";
import ArticleData from "@/pages/ArticleData.vue";
import ServicePage from "@/pages/ServicePage.vue";
import testVue from "@/pages/test.vue";
const router =  new Router({
    routes: [
        {
        path: "/",//默认路由
        component: MainPage,
        meta:{}
        },
        {
        path:"/MainPage",//主页面
        component:MainPage,
        meta:{}
        },
        {
        path: "/noticePage",//通知详情页面
        name: "NoticePage",
        component: NoticePage,
        meta:{}
        },
        {
        path:"/loginPage",//登录页面
        component:LoginPage,
        meta:{}
        },
        {
        path:'/registerPage',//注册页面
        component:RegisterPage,
        meta:{}
        },
        {
        path:'/adminPage',//后台管理页面
        component:AdminPage,
        meta:{requiresAuth: true, requiresAdmin: true}
        },
        {
        path:'/backstageNotice',//后台公告管理
        component:BackstageNotice,
        meta:{requiresAuth: true, requiresAdmin: true}
        },
        {
        path:'/backstageUser',//后台用户管理
        component:BackstageUser,
        meta:{requiresAuth: true, requiresAdmin: true}
        },
        {
        path:'/backstageAdmin',//后台管理人员页面
        component:BackstageAdmin,
        meta:{requiresAuth: true, requiresAdmin: true}
        },
        {
        path:'/userInfo',//用户个人信息页面
        component:UserInfo,
        meta:{requiresAuth:true}
        },
        {
        path:'/communityPage',//社区页面
        component:CommunityPage,
        meta:{}
        },
        {
        path:'/detailComPage',//社区帖子详情页面
        component:DetailComPage,
        meta:{}
        },
        {
        path:'/allNotice',//所有公告
        component:AllNotice,
        meta:{}
        },
        {
        path:'/goodsPage',//周边页面
        component:GoodsPage,
        meta:{}
        },
        {
        path:'/detailGoodsPage',//商品详情
        component:DetailGoodsPage,
        meta:{}
        },
        {
        path:'/carDialog',//购物车 
        component:CarDialog,
        meta:{requiresAuth:true}
        },
        {
        path:'/sellGoods',//发布闲置商品
        component:SellGoods,
        meta:{requiresAuth:true}
        },
        {
        path:'/mesPage',//私信
        component:MesPage,
        meta:{requiresAuth:true}
        },
        {
        path:'/handelInfo',//处理举报信息
        component:HandelInfo,
        meta:{requiresAuth:true,requiresAdmin:true}
        },
        {
        path:'/examineArticle',//处理举报信息
        component:ExamineArticle,
        meta:{requiresAuth:true,requiresAdmin:true}
        },
        {
        path:'/userData',//用户图表
        component:UserData,
        meta:{requiresAuth:true,requiresAdmin:true}
        },
        {
        path:'/articleData',//帖子图表
        component:ArticleData,
        meta:{requiresAuth:true,requiresAdmin:true}
        },
        {
        path:'/servicePage',
        component:ServicePage,
        meta:{}
        },
        {
            path:'/test',
            component:testVue,
            meta:{}
        }
    ],
});

//全局前置路由守卫
//全局前置路由守卫
router.beforeEach((to, from, next) => {
    const token = sessionStorage.getItem('token')
    const role = sessionStorage.getItem('role')
    

    const requiresAuth = to.matched.some(record => record.meta?.requiresAuth)
    const requiresAdmin = to.matched.some(record => record.meta?.requiresAdmin)
  
    // 情况1：需要登录但未登录
    if (requiresAuth && !token) {

      const messageInstance = Message({
        message: '该功能需要登录后才能使用',
        duration: 3000, 
        showClose: true,
        offset: 20,
        customClass: 'auth-message',
        dangerouslyUseHTMLString: true,
        iconClass: 'el-icon-warning',
        // 添加登录按钮
        appendTo: document.body,
        onClose: () => {
          if (clickedLogin) return
          next(false) // 用户没有点击登录，保持当前页面
        }
      })
      
      let clickedLogin = false
      const loginBtn = document.createElement('button')
      loginBtn.className = 'el-button el-button--text el-button--small'
      loginBtn.innerHTML = '<span>立即登录</span>'
      loginBtn.style.marginLeft = '10px'
      loginBtn.onclick = () => {
        clickedLogin = true
        messageInstance.close()
        next({
          path: '/loginPage',
          query: { redirect: to.fullPath }
        })
      }
      
 
      setTimeout(() => {
        const messageEl = document.querySelector('.auth-message')
        if (messageEl) {
          messageEl.querySelector('.el-message__content').appendChild(loginBtn)
        }
      }, 0)
      
      return
    }
  
    // 情况2：需要管理员权限
    if (requiresAdmin && role !== 'admin') {
      Message.error({
        message: '权限不足，该功能仅限管理员使用',
        duration: 2000,
        showClose: true
      })
      return next(from.path) // 返回原页面
    }
  
    // 情况3：已登录用户访问登录/注册页
    if (token && (to.path === '/loginPage' || to.path === '/registerPage')) {
      Message.info('您已登录，将跳转到首页')
      return next('/MainPage')
    }
 
    next() 
  })
export default router;
